module.exports = __webpack_public_path__ + "9fe29ce731f83afa576cd67dcd5ff618.svg";